import React from 'react';
import './FulfillmentInformationDisplay.css';
var defaultProps = {
  lastName: '',
  country: '',
  state: '',
  postalCode: '',
  line1: ''
};
function FulfillmentInformationDisplay(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    line1 = _ref.line1,
    state = _ref.state,
    postalCode = _ref.postalCode,
    country = _ref.country;
  var name = [firstName, lastName].filter(function (x) {
    return !!x;
  }).join(' ');
  var address = [line1, state, postalCode, country].filter(function (x) {
    return !!x;
  }).join(', ');
  return /*#__PURE__*/React.createElement("div", {
    className: "fulfillment-information-display-container"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, name)), /*#__PURE__*/React.createElement("p", null, address));
}
FulfillmentInformationDisplay.defaultProps = defaultProps;
export default FulfillmentInformationDisplay;